import { render, staticRenderFns } from "./journals.vue?vue&type=template&id=25a18138&scoped=true"
import script from "./journals.vue?vue&type=script&lang=js"
export * from "./journals.vue?vue&type=script&lang=js"
import style0 from "./journals.vue?vue&type=style&index=0&id=25a18138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a18138",
  null
  
)

export default component.exports